import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cards-wrap',
  templateUrl: './cards-wrap.component.html',
  styleUrls: ['./cards-wrap.component.scss'],
  standalone: false,
})
export class CardsWrapComponent {
  @Input() heading1: string = '';
  @Input() heading2: string = '';
  @Input() heading3: string = '';
  @Input() heading4: string = '';
  @Input() subheading: string = '';
  @Input() array: {
    imageUrl: string;
    heading: string;
    description: string;
    number: string;
  }[] = [];
}
